import React from 'react';

import { CLIVE_LOTTIE_ANIMATIONS } from '~/components/Clive/cliveLottieAnimations';
import LottieAnimation from '~/components/core/LottieAnimation';
import { Heading, Text } from '~/components/core/TextComponents';

const welcomeTitle = (assistantName: string) => `Hi, I'm ${assistantName} your AI assistant`;

interface WelcomeScreenProps {
  assistantName: string;
  greeting: string;
  children: React.ReactNode;
}

export const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ assistantName, greeting, children }) => (
  <div className="flex flex-1 flex-col items-center justify-center px-24">
    <div className="mb-24 flex flex-col items-center text-center">
      <LottieAnimation animationData={CLIVE_LOTTIE_ANIMATIONS.neutral} className="h-[120px] w-[120px]" />
      <Heading variant={Heading.TYPES.H1} className="my-8">
        {welcomeTitle(assistantName)}
      </Heading>
      <Text
        className="max-w-[600px]"
        variant={Text.VARIANTS.LG}
        colorVariant={Text.COLOR_VARIANTS.SECONDARY}
        weight={Text.WEIGHTS.REGULAR}
      >
        {greeting}
      </Text>
    </div>
    <div className="w-full">{children}</div>
  </div>
);
